import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "text-h5" }, "Регистрация", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-body-2 text-medium-emphasis mt-1" }, "Вы можете зарегистрировать себя как Оператор системы", -1)

import { ref } from 'vue'
import {
  AppAuthService,
  CardIssuePointsService,
  ControlQuestionsService,
  MunicipalEntitiesService,
  SelfRegistrationService,
  UsersService,
} from '@prodcard/core'
import { refObservableValue } from '../../../common'
import { callErrorToast, createCtx, handleError, useWatcherSavedRef, callSuccessToast } from '../../../helpers'
import { SelectCardIssuePointOpts, CheckKeyOpts, RegisterUserOpts } from './interfaces'
import CheckRegistrationKeyForm from './CheckRegistrationKeyForm.vue'
import RegistrationUserForm from './RegistrationUserForm.vue'
import IssuePointSelectForm from './IssuePointSelectForm.vue'
import { useRouter } from 'vue-router'

enum RegistrationStep {
  CHECK_KEY,
  REGISTRATION_USER,
  SELECT_CARD_ISSUE_POINT,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelfRegistrationPage',
  props: {
    authService: {},
    usersService: {},
    selfRegistrationService: {},
    municipalEntitiesService: {},
    controlQuestionsService: {},
    cardIssuePointService: {},
    redirect: {}
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()
const currentUser = refObservableValue(props.authService.authorizedUser)
const currentRegistrationStep = useWatcherSavedRef('currentRegistrationStep', RegistrationStep.CHECK_KEY)

const checkKeyOpts = useWatcherSavedRef<CheckKeyOpts>('stepCheckKeyOpts', {
  email: '',
  registrationKey: '',
})
const loadingCheckKey = ref(false)
const registerUserOpts = useWatcherSavedRef<RegisterUserOpts>('stepRegisterUserOpts', {
  surname: '',
  name: '',
  patronymic: '',
  phone: '',
  password: '',
  controlQuestionId: '',
  controlAnswer: '',
  municipalEntityId: '',
})
const loadingRegisterUser = ref(false)
const loadingUpdateUser = ref(false)

const checkKey = (opts: CheckKeyOpts) => {
  checkKeyOpts.value = opts
  handleError(async () => {
    const response = await props.selfRegistrationService.checkRegistrationCode(
      createCtx(),
      opts.email,
      opts.registrationKey,
    )
    if (response) {
      currentRegistrationStep.value = RegistrationStep.REGISTRATION_USER
    } else {
      callErrorToast('Неверный Email или код регистрации')
    }
  }, loadingCheckKey)
}

const registrationUser = (opts: RegisterUserOpts) => {
  registerUserOpts.value = opts
  handleError(async () => {
    const ctx = createCtx()
    await props.selfRegistrationService.selfRegister(
      ctx,
      {
        email: checkKeyOpts.value.email,
        password: registerUserOpts.value.password,
        surname: registerUserOpts.value.surname,
        name: registerUserOpts.value.name,
        patronymic: registerUserOpts.value.patronymic ? registerUserOpts.value.patronymic : undefined,
        phone: registerUserOpts.value.phone ? registerUserOpts.value.phone : undefined,
        controlQuestionId: registerUserOpts.value.controlQuestionId,
        controlAnswer: registerUserOpts.value.controlAnswer,
        municipalEntityId: registerUserOpts.value.municipalEntityId,
      },
      checkKeyOpts.value.registrationKey,
    )

    const response = await props.authService.login(ctx, checkKeyOpts.value.email, registerUserOpts.value.password)

    if (response?.message) {
      callErrorToast(response.message)
    } else {
      currentRegistrationStep.value = RegistrationStep.SELECT_CARD_ISSUE_POINT
    }
  }, loadingRegisterUser)
}

const selectCardIssuePoint = (opts: SelectCardIssuePointOpts) => {
  handleError(async () => {
    if (!currentUser.value) return

    await props.usersService.update(createCtx(), currentUser.value.id, {
      cardIssuePointId: opts.cardIssuePointId,
    })

    await router.push({ path: props.redirect || '/' })
    callSuccessToast('Данные пользователя сохранены')
  }, loadingUpdateUser)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    width: "100%",
    elevation: "3",
    variant: "flat",
    class: "pa-5",
    loading: loadingCheckKey.value || loadingRegisterUser.value || loadingUpdateUser.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          (_unref(currentRegistrationStep) === RegistrationStep.CHECK_KEY)
            ? (_openBlock(), _createBlock(CheckRegistrationKeyForm, {
                key: 0,
                "default-opts": _unref(checkKeyOpts),
                loading: loadingCheckKey.value,
                onSubmit: checkKey
              }, null, 8, ["default-opts", "loading"]))
            : (_unref(currentRegistrationStep) === RegistrationStep.REGISTRATION_USER)
              ? (_openBlock(), _createBlock(RegistrationUserForm, {
                  key: 1,
                  "default-opts": _unref(RegisterUserOpts),
                  "municipal-entities-service": _ctx.municipalEntitiesService,
                  "control-questions-service": _ctx.controlQuestionsService,
                  loading: loadingRegisterUser.value,
                  onBack: _cache[0] || (_cache[0] = ($event: any) => (currentRegistrationStep.value = RegistrationStep.CHECK_KEY)),
                  onSubmit: registrationUser
                }, null, 8, ["default-opts", "municipal-entities-service", "control-questions-service", "loading"]))
              : (_unref(currentRegistrationStep) === RegistrationStep.SELECT_CARD_ISSUE_POINT)
                ? (_openBlock(), _createBlock(IssuePointSelectForm, {
                    key: 2,
                    "card-issue-point-service": _ctx.cardIssuePointService,
                    "municipal-entities-service": _ctx.municipalEntitiesService,
                    loading: loadingUpdateUser.value,
                    onSubmit: selectCardIssuePoint
                  }, null, 8, ["card-issue-point-service", "municipal-entities-service", "loading"]))
                : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})